import * as amplitude from '@amplitude/analytics-browser'

import Environment from 'helpers/environment'

class Amplitude {
  static apiKey() {
    if (Environment.isProduction()) {
      return '9915ff7cd2acb116142ed004334d392d'
    } else if (Environment.isStaging()) {
      return '48bbd425cb95b6f8776411cd15ce75d8'
    } else if (Environment.isQA()) {
      return '7a69edc6d96eb95432516ace5c1ddb7a'
    } else if (Environment.isQA2() || Environment.isDevelopment()) {
      return 'e4198b636a8a517aa970f2c211281f7d'
    } else {
      return ''
    }
  }

  static init() {
    const apiKey = Amplitude.apiKey()

    if (!apiKey) return

    amplitude.init(apiKey, {
      defaultTracking: {
        sessions: true,
        pageViews: true
      }
    })
  }
}

export default Amplitude
